var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    clipPath: "url(#clip0_0_221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 12.1875C8.00842 12.1875 9.45506 11.5883 10.5217 10.5217C11.5883 9.45506 12.1875 8.00842 12.1875 6.5C12.1875 4.99158 11.5883 3.54494 10.5217 2.47833C9.45506 1.41172 8.00842 0.8125 6.5 0.8125C4.99158 0.8125 3.54494 1.41172 2.47833 2.47833C1.41172 3.54494 0.8125 4.99158 0.8125 6.5C0.8125 8.00842 1.41172 9.45506 2.47833 10.5217C3.54494 11.5883 4.99158 12.1875 6.5 12.1875ZM6.5 2.925C6.79091 2.925 7.0699 3.04056 7.27561 3.24627C7.48131 3.45197 7.59688 3.73097 7.59688 4.02187C7.59688 4.31278 7.48131 4.59178 7.27561 4.79748C7.0699 5.00319 6.79091 5.11875 6.5 5.11875C6.20909 5.11875 5.9301 5.00319 5.72439 4.79748C5.51869 4.59178 5.40313 4.31278 5.40313 4.02187C5.40313 3.73097 5.51869 3.45197 5.72439 3.24627C5.9301 3.04056 6.20909 2.925 6.5 2.925ZM5.525 5.93125H7.475V9.99375H5.525V5.93125Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHint);
export default __webpack_public_path__ + "static/media/hint.b407d70dd6bbee281013b66044072b2d.svg";
export { ForwardRef as ReactComponent };